import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Check = () => import('./views/Check')

const ROUTE_NAME = 'profile:movement:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const CREATE = p('create')
const DISPLAY = p('display')
const CHECK = p('check')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH], options),
      },
    }),
    route('create/', Display, CREATE, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH], options),
      },
    }),
    route(':id/detail/', Display, DISPLAY, {
      props: true,
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH], options),
      },
    }),
    route(':id/check/:method/', Check, CHECK, {
      props: true,
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER, TYPES.STOREKEEPER, TYPES.STOCK_INFO, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR, TYPES.STORE_WH], options),
      },
    }),
  ]
}
